export const TFN_LENGTH = 9
export const TFN_FORMATTED_MAX_LENGTH = 11 // 9 digits + 2 group spaces

export function cleanTfn(value: string): string {
    return value.replace(/\D/g, '').slice(0, TFN_LENGTH)
}

export function formatTfn(value: string): string {
    const cleaned = cleanTfn(value)
    if (cleaned.length <= 3) return cleaned
    if (cleaned.length <= 6) return cleaned.replace(/^(\d{3})(\d{1,3})$/, '$1 $2')
    return cleaned.replace(/^(\d{3})(\d{3})(\d{1,3})$/, '$1 $2 $3')
}

export function isValidTfn(value: string): boolean {
    return cleanTfn(value).length === TFN_LENGTH
}
